export const FieldGuideMaxFileNameLength = 218;

export type FieldGuideFileNameResult =
    | { valid: true; name: string }
    | { valid: false; reason: 'empty' | 'controlCharacter' | 'tooLong' };

const ControlCharacters = /[\u0000-\u001F\u007F]/;
const Extension = '.xlsx';

/** Removes the control characters U+0000-U+001F and U+007F. */
export function stripControlCharacters(input: string): string {
    return input.replace(new RegExp(ControlCharacters.source, 'g'), '');
}

/**
 * Validates a user-entered file name and returns the name to send: directory parts are dropped
 * (the part after the last `/` or `\` is kept) and `.xlsx` is appended when missing. A name that is
 * empty (or only the extension), contains a control character, or is longer than `maxLength` once the
 * extension is added is rejected.
 */
export function validateFieldGuideFileName(raw: string, maxLength: number = FieldGuideMaxFileNameLength): FieldGuideFileNameResult {
    if (ControlCharacters.test(raw)) {
        return { valid: false, reason: 'controlCharacter' };
    }

    const trimmed = raw.trim();
    const name = trimmed.substring(Math.max(trimmed.lastIndexOf('/'), trimmed.lastIndexOf('\\')) + 1).trim();
    const lower = name.toLowerCase();

    if (name === '' || lower === Extension) {
        return { valid: false, reason: 'empty' };
    }

    const finalName = lower.endsWith(Extension) ? name : `${name}${Extension}`;

    return finalName.length > maxLength ? { valid: false, reason: 'tooLong' } : { valid: true, name: finalName };
}
